import * as React from 'react';
import { useState } from 'react';

/** Material UI Packages. */
import { Snackbar, Alert } from '@mui/material';

/** ReactRedux Packages. */
import { useDispatch, useSelector } from 'react-redux';

/** Internal Components. */
import { closeSnackbar } from '../state/slices/snackBarSlice';

export default function CustomSnackbar() {
    /** Load redux state to select the snackbar. */
    const snackBar = useSelector((state) => state.snackBar);
    /** Dispatch a function to update an edited trade partner. */
    const dispatch = useDispatch();

    /** State for snackbar position. */
    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });
    /** Destructure the state. */
    const { vertical, horizontal, open } = state;

    /** Handle to close the snackbar. */
    const handleAlertClose = (event, reason) => {
        // Do nothing if the click is outside the snackbar.
        if (reason === 'clickaway') {
            return;
        }

        dispatch(closeSnackbar());
    };

    return (
        <Snackbar
            open={snackBar.open}
            autoHideDuration={2000}
            onClose={handleAlertClose}
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
        >
            <Alert onClose={handleAlertClose} severity={snackBar.severity} sx={{ width: '100%' }}>
                {snackBar.message}
            </Alert>
        </Snackbar>
    );
}
